import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { adminAnalyticsApi } from '../api/adminApi';
import { OverviewStats, LoadingStatus } from '../../types';

interface AnalyticsState { overview: OverviewStats | null; status: LoadingStatus; error: string | null; }
const initialState: AnalyticsState = { overview: null, status: 'idle', error: null };

export const fetchOverview = createAsyncThunk('analytics/overview', async (_, { rejectWithValue }) => {
  try {
    const res = await adminAnalyticsApi.overview();
    return res.data as OverviewStats;
  } catch (err: unknown) {
    const e = err as { response?: { data?: { message?: string } } };
    return rejectWithValue(e.response?.data?.message || 'Failed to load overview');
  }
});

const slice = createSlice({ name: 'analytics', initialState, reducers: {},
  extraReducers: (b) => {
    b
      .addCase(fetchOverview.pending, (state) => { state.status = 'loading'; state.error = null; })
      .addCase(fetchOverview.fulfilled, (state, { payload }) => { state.overview = payload; state.status = 'succeeded'; })
      .addCase(fetchOverview.rejected, (state, { payload }) => {
        state.status = 'failed';
        state.error = (payload as string) || 'Failed to load overview';
      });
  },
});

export default slice.reducer;
export const selectOverview = (s: { analytics: AnalyticsState }) => s.analytics.overview;
export const selectOverviewStatus = (s: { analytics: AnalyticsState }) => s.analytics.status;
export const selectOverviewError = (s: { analytics: AnalyticsState }) => s.analytics.error;
